import './TodayAppointments.scss';

import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch, useSelector } from 'react-redux';
import dayjs from 'dayjs';

import { loadProviderAppointments } from 'actions/appointments';
import { loadProvider } from 'actions/provider';
import { List } from 'organisms/Appointments/List';
import GroomersDropdown from 'organisms/GroomersDropdown';
import { UserAvatarExtraSmall } from 'organisms/GroomersDropdown/UserAvatar';
import GeneralLoader from 'organisms/Loaders/GeneralLoader';
import NewAppointmentButton from 'organisms/NewAppointmentButton';
import { DISPLAY_NEW_APPOINTMENT_BUTTON } from 'pages/Appointments/Header';

function TodaysAppointments() {
  const dispatch = useDispatch();
  const { uuid: isAdmin } = useSelector((state) => state.adminUser);
  const { selectedGroomer } = useSelector((state) => state.ui);
  const {
    name: providerName,
    providerLoading,
    uuid: providerUuid,
  } = useSelector((state) => state.provider);
  const { appointments, isLoading } = useSelector(
    (state) => state.providerAppointments
  );

  useEffect(() => {
    dispatch(loadProvider(providerUuid)).then(({ success }) => {
      if (success) dispatch(loadProviderAppointments());
    });
  }, []);

  const todaysAppointments = appointments.active.filter(
    (appt) =>
      dayjs(appt.dateStart).format('YYYY-MM-DD') ===
      dayjs().format('YYYY-MM-DD')
  );

  const appointmentsByGroomer =
    selectedGroomer.uuid === 'all'
      ? todaysAppointments
      : todaysAppointments.filter(
          ({ locationUser }) => locationUser.uuid === selectedGroomer.uuid
        );

  return (
    <div className="page-container today-appointments">
      <Helmet title="Appointments | PawCare" />
      <div className="today-appointments-header flex-row justify-between pb-20">
        <h1>{`${isAdmin ? `${providerName}'s t` : 'T'}oday's appointments`}</h1>
        <div className="flex-row gap-24">
          {DISPLAY_NEW_APPOINTMENT_BUTTON && <NewAppointmentButton />}
          <GroomersDropdown Element={UserAvatarExtraSmall} />
        </div>
      </div>
      <div className="today-appointments-content">
        {isLoading || providerLoading ? (
          <GeneralLoader />
        ) : (
          <List
            key={Math.random()}
            items={appointmentsByGroomer}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
}

export default TodaysAppointments;
